import React from 'react';
import PropTypes from 'prop-types';

import { FieldArray } from 'redux-form';

import ProductClaimFieldArray from './ProductClaimFieldArray';

const ProductClaim = ({
  form,
  Patient,
  Diagnosis,
  Facility,
  business,
  systemSettings,
  formValues,
  lazyInitialized,
  disabled,
  ...otherProps
}) => (
  <FieldArray
    name="orderLine"
    component={ProductClaimFieldArray}
    form={form}
    Patient={Patient}
    Diagnosis={Diagnosis}
    Facility={Facility}
    Notes={otherProps.Notes}
    business={business}
    systemSettings={systemSettings}
    formValues={formValues}
    lazyInitialized={lazyInitialized}
    disabled={disabled}
    {...{
      'Order Insurance Param': otherProps['Order Insurance Param'],
    }}
  />
);

ProductClaim.propTypes = {
  form: PropTypes.string.isRequired,
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  Facility: PropTypes.shape({
    ID: PropTypes.number,
  }),
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  'Order Insurance Param': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  systemSettings: PropTypes.object.isRequired,
  lazyInitialized: PropTypes.bool,
  disabled: PropTypes.bool,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
};

ProductClaim.defaultProps = {
  Facility: null,
  business: null,
  formValues: {},
  lazyInitialized: true,
  disabled: false,
};

export default ProductClaim;



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaim.js